import { useBrokerContext } from '@/app/context';
import { requirePermissions } from '@/shared/utils';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { Home } from 'lucide-react';
import { InspectionsContent } from '../../../features/inspections/components';
import { Page, PageHeader } from '../../../shared/ui/page';

export const Route = createFileRoute('/_app/inspections/')({
  component: RouteComponent,
  beforeLoad: async () => {
    const hasPermission = await requirePermissions([
      'policies.inspections.read',
    ]);
    if (!hasPermission) {
      throw redirect({ to: '/dashboard' });
    }
  },
});

function RouteComponent() {
  const { selectedBroker } = useBrokerContext();

  return (
    <Page.Root>
      <Page.Breadcrumb
        items={[
          {
            label: 'Pagina Inicial',
            href: '/dashboard',
            iconLeft: <Home className='h-4 w-4' />,
          },
          { label: 'Subscrição' },
          { label: 'Propostas em Inspeção', active: true },
        ]}
      />

      <PageHeader.Root>
        <PageHeader.Main>
          <PageHeader.TitleGroup>
            <PageHeader.Title>Propostas em Inspeção</PageHeader.Title>
            <PageHeader.Subtitle>
              Acompanhe, envie e gerencie as inspeções vinculadas às propostas
            </PageHeader.Subtitle>
          </PageHeader.TitleGroup>
        </PageHeader.Main>
      </PageHeader.Root>

      <InspectionsContent selectedBroker={selectedBroker} />
    </Page.Root>
  );
}
